/* eslint-disable */
import * as Types from '../../../../../models/schema.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetClassroomByIdVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetClassroomByIdDTO = { __typename?: 'Query', classes: Array<{ __typename?: 'Class', id: string, title: string, school: { __typename?: 'School', id: string, highFiveRegistrationsEnabled: boolean } }> };


export const GetClassroomByIdDocumentDTO = gql`
    query getClassroomById($id: String!) {
  classes(filter: {id: {equals: $id}}) {
    id
    title
    school {
      id
      highFiveRegistrationsEnabled
    }
  }
}
    `;

/**
 * __useGetClassroomById__
 *
 * To run a query within a React component, call `useGetClassroomById` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomById({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassroomById(baseOptions: Apollo.QueryHookOptions<GetClassroomByIdDTO, GetClassroomByIdVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassroomByIdDTO, GetClassroomByIdVariablesDTO>(GetClassroomByIdDocumentDTO, options);
      }
export function useGetClassroomByIdLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetClassroomByIdDTO, GetClassroomByIdVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassroomByIdDTO, GetClassroomByIdVariablesDTO>(GetClassroomByIdDocumentDTO, options);
        }
export type GetClassroomByIdHookResult = ReturnType<typeof useGetClassroomById>;
export type GetClassroomByIdLazyQueryDTOHookResult = ReturnType<typeof useGetClassroomByIdLazyQueryDTO>;
export type GetClassroomByIdQueryResultDTO = Apollo.QueryResult<GetClassroomByIdDTO, GetClassroomByIdVariablesDTO>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BackgroundJob": [
      "DeleteUserResourceAccessesFromPastSchoolyearsBackgroundJob",
      "DeleteUsersWithoutUserResourceAccessesBackgroundJob",
      "ImportSchoolOnboardingsBackgroundJob",
      "ImportShopItemOrderBundleSheetsBackgroundJob",
      "SyncModuleRegistrationsBackgroundJob"
    ],
    "BingoCampaignAction": [
      "ManualBingoCampaignAction",
      "ManualMeasurementBingoCampaignAction",
      "ModuleRegistrationBingoCampaignAction",
      "PupilCreditsBingoCampaignAction",
      "QuizBingoCampaignAction"
    ],
    "BingoCampaignReward": [
      "GameEnergyBingoCampaignReward",
      "PupilCreditsBingoCampaignReward"
    ],
    "Campaign": [
      "BingoCampaign",
      "VideoCampaign"
    ],
    "SearchItem": [
      "CampaignSearchItem",
      "ChallengeSearchItem",
      "ClassSearchItem",
      "ContentItemSearchItem",
      "DeviceSearchItem",
      "ExerciseSearchItem",
      "ModuleSearchItem",
      "ProjectSearchItem",
      "PupilSearchItem",
      "QuizSearchItem",
      "RegimeSearchItem",
      "RewardSearchItem",
      "SchoolSearchItem",
      "SchoolyearSearchItem",
      "ShopItemSearchItem",
      "UserSearchItem"
    ]
  }
};
      export default result;
    